import { takeLatest, put, call, all } from "redux-saga/effects";
import type { ISaga, CreditCardsData } from "../types";
import {
  fetchBanner,
  fetchBenefits,
  fetchCardContents,
  fetchList,
} from "network/services/creditCards";
import {
  fetchCreditCardsSuccess,
  fetchCreditCardsError,
} from "../actionCreators";

function* processCreditCard(): ISaga {
  try {
    const [banner, benefit, creditCardContent, cardList] = yield all([
      call(fetchBanner),
      call(fetchBenefits),
      call(fetchCardContents),
      call(fetchList),
    ]);

    let payload: CreditCardsData = {
      banner: banner?.data[0],
      cardList: cardList?.data,
      creditCardContent: creditCardContent.data,
      benefit: benefit.data,
    };

    yield put(fetchCreditCardsSuccess(payload));
  } catch (e) {
    console.log("FETCHING CCARDERROR", e);

    yield put(fetchCreditCardsError());
  }
}

export default function* watcher() {
  yield takeLatest("REQUEST_CREDIT_CARDS_DATA", processCreditCard);
}
